<template>
    <div class="carbon-impact" :class="cardSize">
        <div class="item">
            <div class="head">
                <span class="icon">🌱</span>
                <span class="label">{{ $t('carbon-impact.reduce-label') }}</span>
            </div>
            <p class="value">
                {{ carbonText }}
                <span v-if="carbon !== null && carbon !== undefined" class="unit">kgCO₂e</span>
            </p>
        </div>

        <div class="item">
            <div class="head">
                <span class="icon">🎋</span>
                <span class="label">{{ $t('carbon-impact.forest-label') }}</span>
            </div>
            <p class="value small">{{ forestText }}</p>
        </div>
    </div>
</template>

<script>
// 減碳量與桂竹林面積都是換算出來的敘述性數字，折線圖與儀表都表達不了
// 「相當於多少面積的竹林」這種類比，故與能流圖一樣手寫版面。

// 台灣的坪：1 坪 = 3.30579 平方公尺
const M2_PER_PING = 3.30579

export default {
    name: 'CarbonImpactChart',
    props: {
        cardSize: { type: String, default: 'small' },
        // 預設 null 而非 0：沒有讀到發電量時顯示「—」，
        // 顯示 0 會被讀成「今天真的一點都沒減到碳」。
        carbon: { type: Number, default: null },
        area: { type: Number, default: null },
    },
    computed: {
        carbonText() {
            if (this.carbon === null || this.carbon === undefined) return '—'
            return this.carbon.toLocaleString()
        },
        forestText() {
            if (this.area === null || this.area === undefined) return '—'
            const ping = Math.round(this.area / M2_PER_PING)
            return this.$t('carbon-impact.forest-text', {
                area: this.area.toLocaleString(),
                ping: ping.toLocaleString(),
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.carbon-impact {
    // 專案沒有全域的 border-box，少了這行左右內距會加在 100% 之外，
    // 整塊比卡片寬 28px，竹林那句就會頂出卡片右緣
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
    padding: 4px 14px;
    color: #4a5568;
    // 卡片預設置中，但這裡是「標籤 + 一句敘述」的清單，
    // 置中會讓標籤靠左、數值卻飄在中間，且長句換行後尾巴懸空
    text-align: left;
}

.item {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.head {
    display: flex;
    align-items: center;
    gap: 6px;
}

.icon {
    font-size: 15px;
    line-height: 1;
}

.label {
    font-size: 13px;
    font-weight: bold;
    color: #11caa0;
}

.value {
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    line-height: 1.25;

    // 竹林那句是一整段敘述，用數值的字級會擠成三四行把卡片撐破
    &.small {
        font-size: 13px;
        font-weight: normal;
        line-height: 1.45;
    }
}

.unit {
    font-size: 13px;
    font-weight: normal;
    margin-left: 2px;
}

// 放大檢視時版面寬鬆得多，字級跟著放大才不會顯得空
.large {
    gap: 28px;

    .label {
        font-size: 16px;
    }
    .value {
        font-size: 38px;

        &.small {
            font-size: 17px;
        }
    }
    .unit {
        font-size: 17px;
    }
}
</style>
